import ActionTypes from 'app/homepage/ActionTypes';

const actions = {
  updateAppSearchQuery(query) {
    return {
      type: ActionTypes.CHANGE_APP_SEARCH_QUERY,
      query,
    };
  },

  changeAppSearchService(service) {
    return {
      type: ActionTypes.SELECT_SERVICE_SEARCH_SERVICE,
      service,
    };
  },
};

export default actions;
